/* eslint-disable */
import Vue from "vue";

var updateText = function (el, binding, vnode) {
    var enableLettersOnly = binding.value;
    var pattern = /[^a-z A-Z -.]/g;
    if (enableLettersOnly && el.value.length > 0) {
        let newValue = el.value.replace(pattern, '');
        el.value = newValue;

        binding.value = el.value;
    }
};
var isValid = function (ev) {
    var el = ev.currentTarget;
    return el.validity.valid || (el.value = '');
};
var preventUpdate = function (e) {
    let charCode = (e.which) ? e.which : e.keyCode;

    if ((charCode > 32 && (charCode !== 45 && charCode !== 46 && charCode !== 40 && charCode !== 41) && charCode < 65) || (charCode > 90 && charCode < 97) 
    || (charCode > 122 && charCode !== 127)) {
        e.preventDefault();
    } else {
        return true;
    }

    // if (charCode === 45 || charCode === 32 ||  charCode === 46 || charCode === 189 || (event.charCode >= 65 && event.charCode <= 90) || 
    //         (event.charCode >= 97 && event.charCode <= 122)) {
    //     return true;
    // } else {
    //     e.preventDefault();
    // }
};

export const LettersOnly = {
    inserted: function (el, binding, vnode) {
        updateText(el, binding, vnode);
    },
    bind(el, binding, vnode) {
        var enabled = binding.value;

        if (enabled) {
            el.valueChanged = function (event) {
                updateText(el, binding, vnode);
            };
            el.addEventListener('input', isValid);
            el.addEventListener('keypress', preventUpdate);
        }
    },
    unbind: function (el, binding) {
        var enabled = binding.value;
        if (enabled) {
            document.removeEventListener('input', isValid);
            document.removeEventListener('keypress', preventUpdate);
        }
    }
};

Vue.directive('letters-only', LettersOnly);